import React from 'react';
import PropTypes from 'prop-types';
import $ from "jquery";

export default class ValidationButton extends React.Component {
  constructor(props) {
    super(props);
    this.errorRef = React.createRef();
  }

  render() {
    const disabled = !this.props.valid || !!this.props.errorMessage;

    const spanStyle = {
      padding: "0"
    };

    return (
      <div className={"btn"} ref={this.errorRef} data-toggle={"tooltip"} title={this.props.errorMessage} style={spanStyle}>
        <button
          type={"button"}
          className={this.props.className}
          disabled={disabled}
          onClick={this.props.buttonAction}
          style={this.hoverStyle()}>
          {this.props.buttonText}
        </button>
      </div>
    );
  }

  hoverStyle() {
    if (this.props.errorMessage) {
      return { pointerEvents: "none" };
    } else {
      return {};
    }
  }

  activateTooltip() {
    if (this.props.errorMessage) {
      $(this.errorRef.current).tooltip();
    }
  }

  componentDidMount() {
    this.activateTooltip();
  }

  componentDidUpdate() {
    this.activateTooltip();
  }

  componentWillUpdate() {
    $(this.errorRef.current).tooltip('dispose');
  }
}

ValidationButton.propTypes = {
  buttonText:   PropTypes.string,
  errorMessage: PropTypes.string,
  buttonAction: PropTypes.func,
  className:    PropTypes.string,
  valid:        PropTypes.bool
};

ValidationButton.defaultProps = {
  valid: true
};
